import React from 'react';
import { ShapeSectionOptions } from './ShapePanel';
import { useMapEditor } from '../../../contexts/MapEditorContext';
import { PanelSectionWrapper } from './PanelSectionWrapper';
import { DragNumberInput } from '../../controls/ScrollDragNumberInput';

export const RectPanelControls: React.FC<ShapeSectionOptions> = ({
  shapes
}) => {
  const { updateShape } = useMapEditor();
  const shape = shapes[0];

  const handleCornerRadiusChangeValue = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { cornerRadius: Number.parseInt(String(value)) });
    });
  };

  return (
    <PanelSectionWrapper title={'Rectangle'}>
      <div className={'flex gap-2'}>
        <div className="flex flex-col gap-1">
          <div className="text-sm font-medium">Edge rounding</div>
          <DragNumberInput
            size={'sm'}
            value={shape.cornerRadius || 0}
            onChange={handleCornerRadiusChangeValue}
            min={0}
          />
        </div>
      </div>
    </PanelSectionWrapper>
  );
};
